import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

let order = 0;

export default Factory.extend({
  page: 'pageKey',
  skippable: false,
  prerequisiteText() {
    return faker.lorem.words();
  },
  stepNumber() {
    return order;
  },
  deliveriesSetupBarOrder() {
    return order;
  },
  subtitle() {
    return faker.lorem.words();
  },
  title() {
    return faker.lorem.word();
  },
  afterCreate() {
    order++;
  },
});
